const checkIsSsnTemporary = (ssn: string) => {
  const genderNumbers = ssn.substring(7, 10);
  const isTempSSN =
    parseInt(genderNumbers) >= 900 && parseInt(genderNumbers) <= 999;
  return isTempSSN;
};

export default checkIsSsnTemporary;
